module.exports = __webpack_public_path__ + "img/logo-neftys-white.4a05ee5a.svg";